import { SxProps } from "@mui/material";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import { HOME_LAYOUT_HEIGHT, HOME_LAYOUT_WIDTH } from "../../../../app/common";

type Props = {
  sx?: SxProps;
  fullSize?: boolean;
  size?: number;
};

const LoadingSpinner = ({ sx, fullSize = false, size }: Props) => {
  return (
    <Box
      sx={{
        height: "100%",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        ...(fullSize && {
          position: "absolute",
          width: HOME_LAYOUT_WIDTH,
          height: HOME_LAYOUT_HEIGHT,
        }),
        ...sx,
      }}
    >
      <CircularProgress size={size} />
    </Box>
  );
};

export default LoadingSpinner;
